import { Option } from '@/core/interfaces';

const option = process.env.VITE_SETTING_OPTIONS?.split('|');
const optionImage = process.env.VITE_SETTING_OPTIONS_IMAGE?.split('|');
const imageUrl = process.env.VITE_SETTING_IMAGES_URL;

export const networkData: Option[] = [];

option?.map((opt, index) => {
	networkData.push({
		id: index,
		name: opt,
		image:
			optionImage && optionImage[index]
				? `${imageUrl + optionImage[index]}`
				: '',
	});
});
